export default __webpack_public_path__ + "static/media/guide_dev_02.5e21abda.md";